
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Tietolähde',
	'dataSourceId': 'Tunnus',
	'dataSourceType': 'Tyyppi',
	'dataSourceName': 'Nimi',
	'dataSourcePath': 'Polku',
	'showInfoForAll': 'Näytä kaikkien visualisointien kesto',
	'hideInfoForAll': 'Piilota kaikkien visualisointien kesto',
	'showPerformanceDetails': 'Sisällytä suorituskykytiedot ajamalla kaikki pienoisohjelmat uudelleen',
	'slotMappingField': 'Paikkojen vastaavuusmääritykset',
	'slotDataMapping': 'Vastaavuusmääritys',
	'slotID': 'Tunnus',
	'slotCaption': 'Kuvateksti',
	'slotMandatory': 'Pakollinen',
	'slotIsMandatory': 'Kyllä',
	'slotIsNotMandatory': 'Ei',
	'infoNotAvailable': 'Ei käytettävissä',
	'performanceSection': 'Suorituskyky',
	'durationField': 'Kesto',
	'singleQueryTime': 'Palvelinkysely (ms)',
	'multipleQueryTime': 'Palvelinkysely %{name} (ms)',
	'liveWidgetTotalTime': 'Yhteensä (ms)',
	'renderTimeNotAvailable': 'Ei käytettävissä',
	'renderInProgress': '(meneillään)',
	'interactToTriggerQuery': 'Käynnistä kysely pienoisohjelman avulla',
	'fetchQuery': 'Nouda kysely',
	'showSQLMDX': 'Näytä SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Kyselytiedot',
	'queryInfoNotAvailable': 'Kyselytiedot eivät ole saatavilla',
	'query': 'Kysely',
	'copy': 'Kopioi',
	'close': 'Sulje'
});
